import { render, staticRenderFns } from "./organizationInfo.vue?vue&type=template&id=12e18305&scoped=true"
import script from "./organizationInfo.vue?vue&type=script&lang=js"
export * from "./organizationInfo.vue?vue&type=script&lang=js"
import style0 from "./organizationInfo.vue?vue&type=style&index=0&id=12e18305&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e18305",
  null
  
)

export default component.exports